/**
 * Plugin Nuxt untuk menyediakan instance `$api` shared.
 *
 * Instance ini menjadi pintu masuk semua request HTTP di layer template/base,
 * sehingga konfigurasi `baseURL` cukup dijaga di satu tempat.
 */
export default defineNuxtPlugin(() => {
  const apiUrl = String(useRuntimeConfig().public.apiUrl);

  const $api = $fetch.create({
    baseURL: apiUrl,
  });

  return {
    provide: {
      api: $api,
    },
  };
});
